import { faShareNodes } from "@fortawesome/pro-light-svg-icons";
import { useCopyToClipboard } from "@uidotdev/usehooks";
import { useMemo, useState } from "react";
import { PrimaryButton } from "../../../../ui/Buttons";
import { useMapData, useMapFilters } from "../../hooks/mapDataAndFilters";
import { useMap } from "../../hooks/mapState";
import { ToolBarDropdown } from "../../ui/MapControlsV2";
import { MenuCategory } from "../../ui/Menu";
import { serializeMapStates } from "../../utils/state";

interface ShareMapControlProps {
    className?: string;
}

const ShareMapControlContents = () => {
    const mapState = useMap("mainMap");
    const { selectedContext } = useMapData("mainMap");
    const { filterState } = useMapFilters("mainMap");
    const [, copyToClipboard] = useCopyToClipboard();
    const [textCopied, setTextCopied] = useState(false);

    const url = useMemo(() => {
        return `${window.location.href}?mapState=${serializeMapStates(
            {
                _viewState: mapState._viewState,
                basemap: mapState.basemap,
                debounced: mapState.debounced,
            },
            filterState,
            selectedContext,
        )}`;
    }, [mapState, selectedContext, filterState]);

    const copyUrl = () => {
        copyToClipboard(url);
        setTextCopied(true);
        setTimeout(() => {
            setTextCopied(false);
        }, 600);
    };

    return (
        <div className="w-64">
            <MenuCategory>Share your current map view:</MenuCategory>
            <div className="flex flex-row space-x-2 items-center mt-1">
                <input
                    type="text"
                    value={url}
                    className="w-full rounded h-9 text-sm"
                    onClick={(e: any) => e.target.select()}
                    readOnly
                />
                <PrimaryButton onClick={copyUrl}>
                    {textCopied ? "Copied" : "Copy"}
                </PrimaryButton>
            </div>
        </div>
    );
};

export const ShareMapControl = (props: ShareMapControlProps) => {
    return (
        <ToolBarDropdown
            enabled={true}
            icon={faShareNodes}
            label="Share"
            className={props.className}
        >
            <ShareMapControlContents />
        </ToolBarDropdown>
    );
};
